
import React from 'react';
import {DashboardContainer, Info} from "../../../funcs/utils";
import BannerMenu from "../../BannerMenu";
import {CreateCustomer, create_customer_state} from "./create-customer";
import {PollSample} from "../../../helper/poll-sample";
import {createDwollaCustomer, loadDwolla} from "../../../payment/actions";
import {DwollaCustomerTypes, DwollaUserTypes} from "../../../../lib/dwolla/constants";
import {count_funding_sources} from "../../../../lib/dwolla/utils";
import { AddPaymentSource, init_state } from "./add-payment-source";
import {FlowRender} from "../../../../lib/flow-render";
import { UGMA_INVITE_PAYMENT_TYPE } from "./prms";
import {TDAAddresses} from "../../../funcs/tda";
import {MakePaymentCard, init_make_payment } from "./make-payment-card";
import {PaymentDone} from "./payment-done";
import {launch_iav} from "../../../payment/iav-flow";
import {getRGB} from "../../../../lib/color";
import {UGMAContributionSent} from "../../../dashboard/user/actions";

const ALL_PRMS = new FlowRender(0, [
  UGMA_INVITE_PAYMENT_TYPE,
]);

class UGMALanding extends React.Component {

  constructor(props) {
    super(props);
    const state = {
      ...create_customer_state(this),
      ...init_state(),
      ...init_make_payment(this),
      loading: false,
    };
    if (props.user.invite) {
      ALL_PRMS.init(state, props.user.invite.prms, this);
    }
    this.state = state;

    this.dwolla_callback = new PollSample(
      1000,
      () => {
        return new Promise((resolve, reject) => {
          loadDwolla(this.props.user.token,
            null,
            null,
            0)
            .then(dwolla => {
              this.props.dwollaUpdate(dwolla, 0);
              if (dwolla.customer.customer_id) {
                if (count_funding_sources(dwolla) === 0) {
                  launch_iav(this)();
                }
                return resolve(true);
              }
              return resolve(false);
            })
        });
      },
      this.onCreateCustomerError);

    const is_processing = (dwolla, payment_id) => {
      if (payment_id in dwolla.payments
        && dwolla.payments[payment_id].state === "sending") {
        return true;
      }
      // If payment_id is not in queued_payments, then we're still processing
      if (!(payment_id in dwolla.queued_debits)) {
        return true;
      }
      return false;
    };

    this.payment_callback = new PollSample(
      1000,
      () => {
        return new Promise((resolve, reject) => {
          loadDwolla(this.props.user.token,
            null,
            null,
            0)
            .then(dwolla => {

              this.props.dwollaUpdate(dwolla, 0);
              // Stop sampling after the payment is processed.
              const payment_id = this.props.user.invite.payment_id;
              const is_done = !is_processing(dwolla, payment_id);
              console.log("is_done", is_done);
              if (is_done) {
                const invite = this.props.user.invite;
                return UGMAContributionSent(
                  this.props.token,
                  invite.username,
                  invite.index,
                  invite.invite_id)
                  .then(() => {
                    resolve(true);
                  })
              }
              return resolve(false);
            })
        })
      }
    )
  }

  componentWillUnmount = () => {
    this.dwolla_callback.maybeClearTimeout();
    this.payment_callback.maybeClearTimeout();
  }

  onCreateCustomerError = () => {
    this.setState({
      customer_error: "Error creating customer.",
      loading: false,
    });
  }

  createCustomer = () => {
    this.setState({
      loading: true,
      customer_error: "",
    });
    createDwollaCustomer(
      this.props.user.token,
      null,
      0,
      DwollaCustomerTypes.USER,
      DwollaUserTypes.UNVERIFIED)
      .then(() => {
        this.dwolla_callback.startCallback();
      }
    )
  }

  maybeRenderMail = () => {
    if (!UGMA_INVITE_PAYMENT_TYPE.isItemClicked(1, this.state)) {
      return null;
    }
    const bold_style = {
      fontWeight: "bold",
      paddingLeft: "0.3rem",
    }
    const text = "Below are the mailing addresses to send a physical check to "
      + "fund your account. Either through regular or overnight mail (slightly safer).";
    const invite = this.props.user.invite;

    return (
      <div style={{marginTop: "2rem"}}>
        <div>
          Make the check payable to
          <span style={bold_style}>TD Ameritrade Clearing.</span>
          <Info
            component={this}
            id={"ugma_mail"}
            text={text}/>
        </div>
        <div style={{height: "1rem"}}/>
        <p>
          In the memo section, include the account number
          <span style={bold_style}>{invite.tda_account_number}</span> and
          <span style={bold_style}>{invite.trustee_name}</span>'s name.
        </p>
        <div style={{height: "1rem"}}/>
        <TDAAddresses/>
      </div>
    )
  }

  has_processed_payment = () => {
    const dwolla = this.props.dwolla && this.props.dwolla['0000'];
    if (!dwolla) {
      return false;
    }
    const payment_id = this.props.user.invite.payment_id;
    if (payment_id in dwolla.payments && dwolla.payments[payment_id].state === "pending") {
      return true;
    }
    if (payment_id in dwolla.completed_payment_ids) {
      return true;
    }
    if (payment_id in dwolla.queued_debits) {
      return true;
    }
    return false;
  }

  render = () => {
    const invite = this.props.user.invite;

    if (!invite) {
      return null;
    }
    const trustee_name = invite.trustee_name;
    const dwolla = this.props.dwolla && this.props.dwolla['0000'];
    let elem;

    if (!UGMA_INVITE_PAYMENT_TYPE.isItemClicked(1, this.state)) {
      if (!dwolla.customer.customer_id) {
        elem = (<CreateCustomer component={this} state={this.state}/>);
      } else if (count_funding_sources(dwolla) === 0) {
        elem = (<AddPaymentSource component={this} state={this.state}/>);
      } else if (this.has_processed_payment()) {
        elem = (<PaymentDone dwolla={dwolla}/>);
      } else {
        elem = (
          <div>
            { /* <PaymentSourceCard component={this} state={this.state}/> */ }
            <MakePaymentCard component={this} state={this.state}/>
          </div>
        );
      }
    }

    const containerStyle = {
      minHeight: "40rem",
    };

    const renderType = index => {
      return (
        <div>
          { UGMA_INVITE_PAYMENT_TYPE.renderCheckbox(index, this) }
          { UGMA_INVITE_PAYMENT_TYPE.renderLabel(index, this.state) }
        </div>
      )
    }
    const client = this.props.client;
    return (
      <section className="UGMALanding">
        <BannerMenu
          bannerColor={getRGB(client.color.banner_background)}/>

        <div className='img-col'>
          <div className="page-container">
            <div className="container" style={containerStyle}>
              <DashboardContainer
                client={this.props.client}
                title={"Friends and Family Contribution"}>
                <div>
                  Contribute to {trustee_name}'s UGMA Account
                </div>
                <div style={{height: "2rem"}}/>
                { renderType(0) }
                { renderType(1) }
                { this.maybeRenderMail() }
              </DashboardContainer>
              { elem }
            </div>
          </div>
        </div>
      </section>
      )
  }
}

export { UGMALanding };
